import { getExpiration } from "../../../Utils/expiration";

// Definiciones de los selectores de filtro de cada sección.
// Cada filtro sabe qué opciones ofrecer y qué valor tiene cada fila.

export type FilterOption = { value: string; label: string };

export type FilterDef = {
  id: string;
  label: string;
  options: FilterOption[];
  getValue: (row: any) => string | null;
};

const isEmpty = (value: any) => value === null || value === undefined || String(value).trim() === "";

const byLabel = (a: FilterOption, b: FilterOption) => a.label.localeCompare(b.label, "es");

// Opciones fijas
export const selectFilter = (
  id: string,
  label: string,
  options: FilterOption[],
  getValue: (row: any) => string | null
): FilterDef => ({ id, label, options, getValue });

// Opciones con los valores distintos que aparecen en las filas (hosting, departamento...)
export const distinctFilter = (id: string, label: string, rows: any[] | null, field: string): FilterDef => {
  const values = new Set<string>();
  (rows ?? []).forEach((row) => {
    if (!isEmpty(row[field])) values.add(String(row[field]).trim());
  });
  return {
    id,
    label,
    options: Array.from(values).map((v) => ({ value: v, label: v })).sort(byLabel),
    getValue: (row) => (isEmpty(row[field]) ? null : String(row[field]).trim()),
  };
};

// Opciones con los nombres de una lista (partner, tipo de licencia...) presentes en las filas
export const listFilter = (
  id: string,
  label: string,
  rows: any[] | null,
  field: string,
  list: any[] | null
): FilterDef => {
  const present = new Set((rows ?? []).map((row) => String(row[field])));
  return {
    id,
    label,
    options: (list ?? [])
      .filter((item: any) => present.has(String(item.id)))
      .map((item: any) => ({ value: String(item.id), label: item.name }))
      .sort(byLabel),
    getValue: (row) => (isEmpty(row[field]) ? null : String(row[field])),
  };
};

export const yesNoFilter = (id: string, label: string, field: string): FilterDef =>
  selectFilter(
    id,
    label,
    [
      { value: "si", label: "Sí" },
      { value: "no", label: "No" },
    ],
    (row) => (row[field] ? "si" : "no")
  );

// Mismo criterio que el color de la fecha (ExpirationDate)
export const expirationFilter = (field = "expiration_day"): FilterDef =>
  selectFilter(
    "expiration",
    "Vencimiento",
    [
      { value: "expired", label: "Vencida" },
      { value: "warning", label: "Próxima a vencer (días de aviso)" },
      { value: "valid", label: "Vigente" },
      { value: "none", label: "Sin vencimiento" },
    ],
    (row) => getExpiration(row[field], row.advise_days)?.status ?? "none"
  );
